import styled from "styled-components";

export const Container = styled.div`
	background-color: #ffffff;
	height: 539px;
	width: 722px;
	border-radius: 30px;
	place-content: center;
	color: black;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;

	.close {
		width: 21px;

		position: absolute;
		right: 1.5rem;
		top: 1.5rem;

		cursor: pointer;
	}

	.alert {
		margin-bottom: 3rem;
		width: 12%;
	}

	.divText {
		width: 65%;
	}

	.text {
		color: #b3b3b3;
		font-weight: 500;
		font-family: Roboto;
		font-size: 26px;
		line-height: 30.47px;
		text-align: center;
		margin-bottom: 2rem;
	}

	.buttons {
		width: 70%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 5rem;
		cursor: pointer;
	}

	.button {
		font-family: Roboto;
		font-size: 1.5rem;
		line-height: 1.758rem;
		color: #8c8e86;
		margin: 1.5rem 2.6rem;
		border: 0;
		background: transparent;
	}

	.option {
		display: flex;
		flex-direction: column;
		align-items: center;
		label {
			cursor: pointer;
		}
	}
`;
